module.exports = new __parcel__URL__("aboutSite.371760e3.png").toString();